const ENGLISH_ONLY_DOCUMENTS = new Set([
  '/career',
  '/legal/cookies',
  '/legal/privacy',
  '/legal/terms',
  '/ai-werewolf-benchmark',
  '/mafia-ai-benchmark',
  '/board-game-ai-benchmark',
  '/social-deduction-ai-benchmark',
])

export function resolveAvailableContentLocale(requested, available) {
  const published = new Set(available)
  if (published.has(requested))
    return requested
  if (requested === 'tw' && published.has('zh'))
    return 'zh'
  if (published.has('en'))
    return 'en'
  return available[0] ?? null
}

export function resolvePublicContentLocale(pagePath, requested, articleLocales) {
  if (pagePath === '/faq')
    return resolveAvailableContentLocale(requested, ['en', 'zh'])
  if (ENGLISH_ONLY_DOCUMENTS.has(pagePath))
    return 'en'
  if (/^\/blogs\/[a-z0-9-]+$/.test(pagePath) && articleLocales)
    return resolveAvailableContentLocale(requested, articleLocales)
  return requested
}
